<template>
<div>
      <p class="detail-table-name">Other</p>
      <table class="detail-table w-100">
        <thead>
        <tr>
          <th>Workshop</th>
          <th>Meeting</th>
        </tr>
        </thead>
        <tbody>
          <tr v-for="other of others" :key="other.index">
            <td>{{ other.workshop }} Hr</td>
            <td>{{ other.meeting }} Hr</td>
          </tr>
        </tbody>
      </table>
      <p class="unit-name">Unit: Hours</p>
    </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import { Other, Timesheet } from '@/store/timesheets/types'
import { Moment } from 'moment'
import _ from 'lodash'

@Component
export default class OtherComponent extends Vue {
  @Prop() date!: Moment

  @Prop() others!: Other[]
}
</script>

<style scoped>
.detail-table-name {
  border-left:3px solid #BFBFBF;
  padding-left:5px;
  margin-bottom:10px;
  font-weight: bold;
}

.detail-table {
  table-layout: fixed;
  border-collapse:collapse;
  margin-bottom:10px;
}

.detail-table th {
  padding:10px;
  text-align: center;
}

.detail-table td {
  padding:10px;
  text-align: center;
}

.detail-table thead tr {
  background: #fff;
  border: 2px solid #dcdcdc
}

.detail-table tbody tr:nth-child(odd) {
  background: #D8D8D8;
}

.detail-table tbody tr:nth-child(even) {
  background: #fff;
}

.detail-table tbody tr.total {
  background: #D8E2F3;
}

.unit-name {
  text-align: right;
}
</style>
